import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { ServiceIdentityBaseSchema } from './base';
export const ListServiceIdentitiesResponseSchema = z.object({
    items: z.array(ServiceIdentityBaseSchema),
});
export class ListServiceIdentitiesResponseDto extends createZodDto(ListServiceIdentitiesResponseSchema) {
}
